import React from 'react'
import { AUTH_PERMISSION_KEYS } from 'constants/auth-permission-keys'
import { tutorialTypes } from 'constants/tutorials'
import type { Locale } from 'date-fns'
import useFavurTranslation from 'hooks/useFavurTranslation'
import useHistoryUtils from 'hooks/useHistoryUtils'
import useRolesViews from 'hooks/useRolesViews'
import Alert from 'redesign/components/atoms/alert'
import TaskDetailsHeader from 'redesign/components/organisms/headers/task-details-header'
import { TASK_DETAILS_PAGE_ROOT_ID } from 'redesign/pages/task-details/constants'
import routes from 'services/RoutesProvider/routes'
import { TASK_STATES } from '../ContentLists/TaskList/constants'
import Page from '../Page'
import { getActionButtons } from '../task-details-action-buttons/utils/get-action-buttons'
import { TASK_TYPE_TITLE } from '../task-details/constants'
import type { TaskDetailsProps, TaskTypeKey } from '../task-details/types'
import Timeline from '../timeline'
import { createTimeline } from '../timeline/factory/timeline-factory'

const SecureConnectionDetails: React.FC<TaskDetailsProps> = ({ task, refetch }) => {
  const { t, locale } = useFavurTranslation()
  const { personIds, isOffice } = useRolesViews()
  const { pushWithRole } = useHistoryUtils()
  const timelineItems = createTimeline({
    task,
    t,
    locale: locale as Locale,
    personIds,
    isOffice,
  })
  const showTutorialAlert = !isOffice && task.statusFe !== TASK_STATES.closed

  return (
    <Page
      hideNativeNavigation
      rootId={TASK_DETAILS_PAGE_ROOT_ID}
      header={<TaskDetailsHeader title={t(TASK_TYPE_TITLE[task.taskType as TaskTypeKey])} />}
      footer={getActionButtons({
        task,
        refetch,
        workflowPermissions: AUTH_PERMISSION_KEYS.workflowSecureConnection,
      })}
    >
      {showTutorialAlert && (
        <Alert
          title={t('page.secureConnectionDetails.alert.title')}
          body={t('page.secureConnectionDetails.alert.content')}
          severity="info"
          onClick={() =>
            pushWithRole(`${routes.tutorial}/${tutorialTypes.secureConnection}?taskUuid=${task.favurUuid}`)
          }
        />
      )}
      <Timeline items={timelineItems} isOffice={isOffice} />
    </Page>
  )
}

export default SecureConnectionDetails
